var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26634 21H18.8402V19.1179H12.2919V19.0114L15.1825 15.9858C17.8459 13.294 18.6058 12.0085 18.6058 10.3821C18.6058 8.04545 16.7024 6.25568 13.9609 6.25568C11.2408 6.25568 9.25213 8.01705 9.25213 10.6733H11.3473C11.3402 9.1108 12.3487 8.08807 13.9183 8.08807C15.3956 8.08807 16.5178 8.99716 16.5178 10.446C16.5178 11.7315 15.7507 12.6548 14.1882 14.3097L9.26634 19.4091V21Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoActive);
export default __webpack_public_path__ + "static/media/two-active.4a60e81ddd7a31b6a586ba8e7e202578.svg";
export { ForwardRef as ReactComponent };